import { TPaymentMethodType } from 'shared/domain/entities';

export const checkoutQueries = {
  base: ['checkout'] as const,

  budget: (id: number | undefined) =>
    [...checkoutQueries.base, 'budget', id] as const,

  cardInstallmentsByBudget: (budgetId: number | undefined) =>
    [...checkoutQueries.base, 'cardInstallments', budgetId] as const,

  cardInstallments: (
    budgetId: number | undefined,
    cardNumber: string | undefined,
    flag: string | undefined,
    method: TPaymentMethodType | undefined,
  ) =>
    [
      ...checkoutQueries.cardInstallmentsByBudget(budgetId),
      cardNumber,
      flag,
      method,
    ] as const,

  automaticDebitInstallments: (budgetId: number | undefined) =>
    [...checkoutQueries.base, 'automaticDebitInstallments', budgetId] as const,

  citiesByName: (name: string | undefined) =>
    [...checkoutQueries.base, 'citiesByName', name] as const,

  districtsByCityAndName: (
    cityId: number | undefined,
    name: string | undefined,
  ) =>
    [...checkoutQueries.base, 'districtsByCityAndName', cityId, name] as const,

  /**
   * A assinatura muda junto com o carrinho — itens e cupom. É o que faz a simulação ser
   * refeita quando o cliente mexe no carrinho, e reaproveitada quando ele só navega.
   */
  cartPaymentMethods: (signature: string) =>
    [...checkoutQueries.base, 'cartPaymentMethods', signature] as const,
  customerPendencies: (customerId: number | undefined) =>
    [...checkoutQueries.base, 'customerPendencies', customerId] as const,

  budgetStatus: (budgetId: number | undefined) => [
    ...checkoutQueries.base,
    'budgetStatus',
    budgetId,
  ],
};
